import DrawDefault, * as DrawNS from './../../node_modules/ol/interaction/Draw.js';
import MapBrowserEventType from './../../node_modules/ol/MapBrowserEventType.js';
import EventType from './../../node_modules/ol/events/EventType.js';

class Draw extends DrawDefault {

    constructor(options) {
        super(options);
    }

    handleEvent(event) {
        const map = this.getMap();
        if (!map) return;

        const bullsEye = map.get('BullsEyeControl');

        // 🎯 Override pointer with bullseye position
        if (bullsEye && bullsEye.active) {
            event.pixel = bullsEye.getPixel();
            event.coordinate = bullsEye.getPosition();
        }

        // ===== ORIGINAL OpenLayers logic (unchanged) =====

        if (event.originalEvent.type === EventType.CONTEXTMENU) {
          // Avoid context menu for long taps when drawing on mobile
          event.originalEvent.preventDefault();
        }
        this.freehand_ = this.mode_ !== 'Point' && this.freehandCondition_(event);
        let move = event.type === MapBrowserEventType.POINTERMOVE;
        let pass = true;
        if (
          !this.freehand_ &&
          this.lastDragTime_ &&
          event.type === MapBrowserEventType.POINTERDRAG
        ) {
          const now = Date.now();
          if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
            this.downPx_ = event.pixel;
            this.shouldHandle_ = !this.freehand_;
            move = true;
          } else {
            this.lastDragTime_ = undefined;
          }
          if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
            clearTimeout(this.downTimeout_);
            this.downTimeout_ = undefined;
          }
        }
        if (
          this.freehand_ &&
          event.type === MapBrowserEventType.POINTERDRAG &&
          this.sketchFeature_ !== null
        ) {
          this.addToDrawing_(event.coordinate);
          pass = false;
        } else if (
          this.freehand_ &&
          event.type === MapBrowserEventType.POINTERDOWN
        ) {
          pass = false;
        } else if (move && this.getPointerCount() < 2) {
          pass = event.type === MapBrowserEventType.POINTERMOVE;
          if (pass && this.freehand_) {
            this.handlePointerMove_(event);
            if (this.shouldHandle_) {
              // Avoid page scrolling when freehand drawing on mobile
              event.originalEvent.preventDefault();
            }
          } else if (
            event.originalEvent.pointerType === 'mouse' ||
            (event.type === MapBrowserEventType.POINTERDRAG &&
              this.downTimeout_ === undefined)
          ) {
            this.handlePointerMove_(event);
          }
        } else if (event.type === MapBrowserEventType.DBLCLICK) {
          pass = false;
        }
    
        return super.handleEvent(event) && pass;
      }

      handlePointerMove_(event) {
        const map = this.getMap();
        if (!map) return;

        const bullsEye = map.get('BullsEyeControl');
         // 🎯 Override pointer with bullseye position
        if (bullsEye && bullsEye.active) {
            event.pixel = bullsEye.getPixel();
            event.coordinate = bullsEye.getPosition();

              return;
        }

    this.pointerType_ = event.originalEvent.pointerType;
    if (
      this.downPx_ &&
      ((!this.freehand_ && this.shouldHandle_) ||
        (this.freehand_ && !this.shouldHandle_))
    ) {
      const downPx = this.downPx_;
      const clickPx = event.pixel;
      const dx = downPx[0] - clickPx[0];
      const dy = downPx[1] - clickPx[1];
      const squaredDistance = dx * dx + dy * dy;
      this.shouldHandle_ = this.freehand_
        ? squaredDistance > this.squaredClickTolerance_
        : squaredDistance <= this.squaredClickTolerance_;
      if (!this.shouldHandle_) {
        return;
      }
    }

    if (!this.finishCoordinate_) {
      this.createOrUpdateSketchPoint_(event.coordinate.slice());
      return;
    }

    this.updateTrace_(event);
    this.modifyDrawing_(event.coordinate);
  }

    handleUpEvent(event) {
        const map = this.getMap();
        if (!map) return;

        const bullsEye = map.get('BullsEyeControl');

        // 🎯 Override pointer with bullseye position
        if (bullsEye && bullsEye.active) {
            event.pixel = bullsEye.getPixel();
            event.coordinate = bullsEye.getPosition();

            return;
        }

        // ===== ORIGINAL OpenLayers logic (unchanged) =====
        let pass = true;

        if (this.getPointerCount() === 0) {
          if (this.downTimeout_) {
              clearTimeout(this.downTimeout_);
              this.downTimeout_ = undefined;
          }

          this.handlePointerMove_(event);
          const tracing = this.traceState_.active;
          this.toggleTraceState_(event);

          if (this.shouldHandle_) {
              const startingToDraw = !this.finishCoordinate_;
              if (startingToDraw) {
              this.startDrawing_(event.coordinate);
              }
              if (!startingToDraw && this.freehand_) {
              this.finishDrawing();
              } else if (
              !this.freehand_ &&
              (!startingToDraw || this.mode_ === 'Point')
              ) {
              if (this.atFinish_(event.pixel, tracing)) {
                  if (this.finishCondition_(event)) {
                  this.finishDrawing();
                  }
              } else {
                  this.addToDrawing_(event.coordinate);
              }
              }
              pass = false;
          } else if (this.freehand_) {
              this.abortDrawing();
          }
        }

        if (!pass && this.stopClick_) {
          event.preventDefault();
        }
        return pass;
    }

}

// Preserve static exports
Object.entries(DrawNS).forEach(([key, value]) => {
    if (key !== 'default') {
        Draw[key] = value;
    }
});

export default Draw;
export * from 'ol/interaction/Draw.js';
